import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnInit,
} from '@angular/core';
import { IconRegistryService } from '@rd/core/services/icon-registry/icon-registry.service';
import { IconOptions, IconTheme } from '@rd/types';

@Component({
  selector: 'rd-shared-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class IconComponent implements OnInit {
  @HostBinding('class.rd-shared-icon') componentClass = true;
  @HostBinding('class.link') get isLinkIcon(): boolean {
    return this.iconTheme === 'link';
  }
  @HostBinding('class.primary') get isPrimaryIcon(): boolean {
    return this.iconTheme === 'primary';
  }
  @HostBinding('class.success') get isSuccessIcon(): boolean {
    return this.iconTheme === 'success';
  }
  @HostBinding('class.warn') get isWarningIcon(): boolean {
    return this.iconTheme === 'warn';
  }
  @HostBinding('class.error') get isErrorIcon(): boolean {
    return this.iconTheme === 'error';
  }
  @HostBinding('class.white') get iwWhiteIcon(): boolean {
    return this.iconTheme === 'white';
  }
  @HostBinding('class.disabled') get isDisabledIcon(): boolean {
    return this.iconTheme === 'disabled';
  }
  @HostBinding('class.default') get isDefaultIcon(): boolean {
    return this.iconTheme === 'default' || !this.iconTheme;
  }

  @Input() iconSymbol: string;
  @Input() iconTheme: IconTheme;
  @Input() iconOptions: IconOptions;

  constructor(private iconRegistryService: IconRegistryService) {}

  ngOnInit(): void {
    this.iconRegistryService.registerIcon(this.iconSymbol.replace('icon-', ''));
  }

  flippableIcon(): boolean {
    if (this.iconOptions && this.iconOptions.flippable) {
      return true;
    }

    return false;
  }
}
